import { render } from "./DropdownBasic.vue?vue&type=template&id=7ff2b1ba&ts=true"
import script from "./DropdownBasic.vue?vue&type=script&lang=ts"
export * from "./DropdownBasic.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__